// Generated by ts-to-zod
import { z } from 'zod';

export const createSchemaPayloadSchema = z.object({
  name: z.string(),
  content: z.any().optional(),
});
